import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";

const PageNotFound = () => (
    <Layout>
        <h2>
            Page not found, go <Link to="/">Home</Link>
        </h2>
    </Layout>
);

export { PageNotFound };



// WEBPACK FOOTER //
// ./src/pages/PageNotFound.js